import { memo, type SVGProps } from "react"

const SvgComponent = (props: SVGProps<SVGSVGElement>) => {
  const { width = 29, height = 29 } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${width} ${height}`}
          width={width}
      height={height}
      fill="none"
      {...props}
    >
      <path
        fill="#BFBFBF"
        d="M14.41 28.82C6.452 28.82 0 22.37 0 14.41 0 6.452 6.452 0 14.41 0c7.96 0 14.41 6.452 14.41 14.41 0 7.96-6.45 14.41-14.41 14.41Zm0-2.881a11.529 11.529 0 1 0 0-23.058 11.529 11.529 0 0 0 0 23.058Zm-1.44-7.206h2.881v2.883H12.97v-2.883Zm2.881-2.37v.93H12.97V15.13a1.441 1.441 0 0 1 1.441-1.441 2.161 2.161 0 1 0-2.12-2.585l-2.827-.567a5.045 5.045 0 1 1 6.388 5.825Z"
      />
    </svg>
  )
}
const Memo = memo(SvgComponent)
export { Memo as HelpIconDisabled }
